export const MilestoneColorScheme = {
    "palettes": [
        {
            "id": "palette1",
            "ranges": ["#A8D5BA", "#79C79C", "#56B485", "#98D0B7", "#C2E5D8", "#79C79C", "#A8D5BA", "#56B485", "#98D0B7", "#56B485", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette2",
            "ranges": ["#79C79C", "#A8D5BA", "#98D0B7", "#56B485", "#C2E5D8", "#A8D5BA", "#56B485", "#79C79C"]
        },
        {
            "id": "palette3",
            "ranges": ["#98D0B7", "#C2E5D8", "#A8D5BA", "#79C79C", "#56B485", "#A8D5BA", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette4",
            "ranges": ["#C2E5D8", "#98D0B7", "#79C79C", "#56B485", "#A8D5BA", "#98D0B7", "#C2E5D8", "#56B485"]
        },
        {
            "id": "palette5",
            "ranges": ["#56B485", "#79C79C", "#A8D5BA", "#98D0B7", "#C2E5D8", "#A8D5BA", "#56B485", "#79C79C", "#A8D5BA", "#56B485", "#98D0B7", "#79C79C"]
        },
        {
            "id": "palette6",
            "ranges": ["#79C79C", "#A8D5BA", "#C2E5D8", "#56B485", "#98D0B7", "#A8D5BA", "#C2E5D8", "#56B485"]
        },
        {
            "id": "palette7",
            "ranges": ["#A8D5BA", "#C2E5D8", "#79C79C", "#56B485", "#98D0B7", "#A8D5BA", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette8",
            "ranges": ["#C2E5D8", "#79C79C", "#A8D5BA", "#56B485", "#98D0B7", "#79C79C", "#A8D5BA", "#56B485"]
        },
        {
            "id": "palette9",
            "ranges": ["#A8D5BA", "#79C79C", "#56B485", "#98D0B7", "#C2E5D8", "#A8D5BA", "#79C79C", "#56B485", "#A8D5BA", "#98D0B7", "#79C79C", "#C2E5D8"]
        },
        {
            "id": "palette10",
            "ranges": ["#79C79C", "#A8D5BA", "#C2E5D8", "#98D0B7", "#56B485", "#A8D5BA", "#C2E5D8", "#56B485"]
        },
        {
            "id": "palette11",
            "ranges": ["#C2E5D8", "#98D0B7", "#A8D5BA", "#79C79C", "#56B485", "#A8D5BA", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette12",
            "ranges": ["#98D0B7", "#C2E5D8", "#79C79C", "#56B485", "#A8D5BA", "#C2E5D8", "#79C79C", "#98D0B7"]
        },
        {
            "id": "palette13",
            "ranges": ["#A8D5BA", "#79C79C", "#56B485", "#C2E5D8", "#A8D5BA", "#79C79C", "#56B485", "#C2E5D8", "#98D0B7", "#79C79C", "#A8D5BA", "#56B485"]
        },
        {
            "id": "palette14",
            "ranges": ["#79C79C", "#A8D5BA", "#C2E5D8", "#56B485", "#98D0B7", "#A8D5BA", "#79C79C", "#C2E5D8"]
        },
        {
            "id": "palette15",
            "ranges": ["#C2E5D8", "#98D0B7", "#79C79C", "#A8D5BA", "#56B485", "#98D0B7", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette16",
            "ranges": ["#98D0B7", "#C2E5D8", "#79C79C", "#56B485", "#A8D5BA", "#C2E5D8", "#79C79C", "#56B485"]
        },
        {
            "id": "palette17",
            "ranges": ["#A8D5BA", "#79C79C", "#56B485", "#C2E5D8", "#98D0B7", "#79C79C", "#A8D5BA", "#56B485", "#98D0B7", "#A8D5BA", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette18",
            "ranges": ["#79C79C", "#A8D5BA", "#C2E5D8", "#56B485", "#98D0B7", "#79C79C", "#C2E5D8", "#56B485"]
        },
        {
            "id": "palette19",
            "ranges": ["#C2E5D8", "#98D0B7", "#A8D5BA", "#79C79C", "#56B485", "#98D0B7", "#C2E5D8", "#79C79C"]
        },
        {
            "id": "palette21",
            "ranges": ["#C2E5D8", "#E4F4EB", "#79C79C", "#98D0B7", "#FFFFFF"]
        },
        {
            "id": "palette22",
            "ranges": ["#A8D5BA", "#E4F4EB", "#56B485", "#98D0B7", "#79C79C"]
        },
        {
            "id": "palette23",
            "ranges": ["#E4F4EB", "#56B485", "#79C79C", "#A8D5BA", "#98D0B7"]
        },
        {
            "id": "palette24",
            "ranges": ["#56B485", "#79C79C", "#A8D5BA", "#98D0B7", "#E4F4EB"]
        },
        {
            "id": "palette25",
            "ranges": ["#79C79C", "#A8D5BA", "#98D0B7", "#E4F4EB", "#56B485"]
        },
        {
            "id": "palette26",
            "ranges": ["#A8D5BA", "#98D0B7", "#E4F4EB", "#56B485", "#79C79C"]
        },
        {
            "id": "palette27",
            "ranges": ["#98D0B7", "#E4F4EB", "#56B485", "#79C79C", "#A8D5BA"]
        },
        {
            "id": "palette28",
            "ranges": ["#F4FAF7"]
        }
    ],
    "themes": [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette22"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette1", "palette2", "palette3", "palette2", "palette3"]
                },
                {
                    "type": "line",
                    "ranges": ["palette17", "palette3", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette8", "palette7", "palette9", "palette10"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette22", "palette23", "palette24", "palette25", "palette26", "palette27"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette21"]
                },
            ],
            "sidebar": {
                "ranges": ["palette28"]
            }
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette5"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette8", "palette7", "palette4", "palette9", "palette12"]
                },
                {
                    "type": "line",
                    "ranges": ["palette10", "palette11", "palette13"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette9", "palette13", "palette9", "palette10"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette12"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette8", "palette9", "palette10", "palette11", "palette12",]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette13", "palette14", "palette15", "palette16", "palette17"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette7"]
                },
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette16", "palette17"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette16"]
                },
                {
                    "type": "pie",
                    "ranges": ["palette22"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette11", "palette10"]
                },
                {
                    "type": "line",
                    "ranges": ["palette19", "palette10", "palette9", "palette12"]
                }
            ]
        },
        {
            "id": "colorTheme4",
            "name": "colorTheme4",
            "charts": [
                {
                    "type": "bar",
                    "ranges": ["palette1"]
                },
            ]
        }
    ]
}